import { render, staticRenderFns } from "./CoCardResourceGroup.vue?vue&type=template&id=4ef5e370&"
import script from "./CoCardResourceGroup.vue?vue&type=script&lang=ts&"
export * from "./CoCardResourceGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardResourceGroup.vue?vue&type=style&index=0&id=4ef5e370&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports